import { render, staticRenderFns } from "./RecordFeeCreateBasedata.vue?vue&type=template&id=5749d0bc"
import script from "./RecordFeeCreateBasedata.vue?vue&type=script&lang=js"
export * from "./RecordFeeCreateBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports